module.exports = __webpack_public_path__ + "static/media/finance.1ba4ba6a.jpg";